import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { forwardRef } from 'react';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import { useSelectContext } from '../context.mjs';

const Trigger = forwardRef(
  (props, forwardedRef) => {
    const { children, ...restProps } = props;
    const context = useSelectContext();
    const composedRefs = useComposedRefs(forwardedRef, context.onTriggerChange);
    return /* @__PURE__ */ jsx(Legacy_Dropdown.Trigger, { type: "button", ...restProps, ref: composedRefs, children });
  }
);

export { Trigger };
//# sourceMappingURL=Trigger.mjs.map
